var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.breadcrumbs.length
    ? _c("section", { class: _vm.container }, [
        _c(
          "nav",
          {
            staticClass: "container-fluid pt-0",
            attrs: { "aria-label": "breadcrumbs" },
          },
          [
            _c(
              "ul",
              { staticClass: "breadcrumb px-0 mb-0" },
              _vm._l(_vm.breadcrumbs, function (crumb, index) {
                return _c(
                  "li",
                  {
                    key: crumb.name,
                    staticClass: "breadcrumb-item",
                    class: { active: index == _vm.breadcrumbs.length - 1 },
                    attrs: { "aria-current": "page" },
                  },
                  [
                    index < _vm.breadcrumbs.length - 1
                      ? [
                          _c(
                            "router-link",
                            { attrs: { to: _vm.linkProp(crumb) } },
                            [_vm._v(_vm._s(_vm.crumbText(crumb)))]
                          ),
                        ]
                      : [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.crumbText(crumb)) +
                              "\n                    "
                          ),
                        ],
                  ],
                  2
                )
              }),
              0
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }